import { useQuery } from '@tanstack/react-query';

import { BANK_BULK_IMPORT_BY_ID_KEY } from 'hooks/keys';
import { useUser } from 'hooks/queries';
import { BanksApi } from '../../../api';

export function useBankBulkImportById(importId: string) {
  const banksApi = new BanksApi();
  const { userBankId } = useUser();

  const {
    data: bulkImport,
    isLoading: isLoadingBulkImport,
    isError
  } = useQuery({
    enabled: !!userBankId.length,
    queryKey: [BANK_BULK_IMPORT_BY_ID_KEY, userBankId, importId],
    queryFn: () => banksApi.getBulkImportById(userBankId, importId),
    meta: {
      snackbarErrorMessage:
        'There was an issue loading the bulk import. Please try again, or contact support if the problem persists.'
    },
    retry: (failureCount, error) => {
      if ((error as any).code === 404) return false;
      return failureCount < 3;
    }
  });

  return { bulkImport, isLoadingBulkImport, isError };
}
